import React from "react";
import { getAdminData } from "../../Utils/role";
import { Link, useNavigate } from "react-router";

const ProfileDetail = () => {
  const admin = getAdminData();
  const navigate = useNavigate();

  return (
    <div>
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
        <div className="title_member">
          <h4>Profile Details</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Profile Details</span>
          </nav>
        </div>

        <div>
          <button className="total-btn" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
      </div>

      <div className="main_page">
        {/* Profile Card */}
        <div className="border-0">
            <div className="d-flex profile_data">
              <div className="profile_image">
                <div className="text-center">
                  <div className="profile_image_data">
                    <img
                      src={`https://ui-avatars.com/api/?name=${admin?.name || "Admin"}&background=0D6EFD&color=fff&size=150`}
                      alt="Profile"
                      className="rounded-circle border border-3 border-primary"
                      width="130"
                      height="130"
                    />
                  </div>

                  <h5 className="proflename">{admin?.name || "Admin"}</h5>

                  <span
                    className={`status-badge ${
                      admin?.status === "Active" ? "active" : "inactive"
                    }`}
                  >
                    <span className="status-dot"></span>
                    {admin?.status || "Inactive"}
                  </span>
                </div>
              </div>

              <div className="profileeditor">
                {/* Details */}
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <label className="form-label fw-bold">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={admin?.name || ""}
                      readOnly
                    />
                  </div>

                  <div className="col-md-6 mb-4">
                    <label className="form-label fw-bold">Email</label>
                    <input
                      type="text"
                      className="form-control"
                      value={admin?.email || ""}
                      readOnly
                    />
                  </div>

                  <div className="col-md-6 mb-4">
                    <label className="form-label fw-bold">Role</label>
                    <input
                      type="text"
                      className="form-control"
                      value={admin?.role || ""}
                      readOnly
                    />
                  </div>

                  {/* <div className="col-md-6 mb-4">
              <label className="form-label fw-bold">
                Status
              </label>
              <input
                type="text"
                className={`form-control fw-bold ${
                  admin?.status === "Active"
                    ? "text-success border-success"
                    : "text-danger border-danger"
                }`}
                value={admin?.status || ""}
                readOnly
              />
            </div> */}
                  {/* 
            <div className="col-md-6 mb-4">
              <label className="form-label fw-bold">
                Support Number
              </label>
              <input
                type="text"
                className="form-control"
                value="+91 9876543210"
                readOnly
              />
            </div> */}
                </div>
              </div>
            </div>
        
        </div>
      </div>
    </div>
  );
};

export default ProfileDetail;
